import { render, staticRenderFns } from "./GestionEstudioConflictosS2.vue?vue&type=template&id=6c5a006c&"
import script from "./GestionEstudioConflictosS2.vue?vue&type=script&lang=js&"
export * from "./GestionEstudioConflictosS2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports